
export default {
  props: {
    pageTitle: { type: [Array, String], default: () => [] },
    pageType: { type: String, default: "" },
  },

  data: () => ({ breadCrumbs: [] }),

  head() {
    if (
      this.breadCrumbs.length === 0 ||
      (this.pageType !== "Product_list_page" &&
        this.pageType !== "L2_product_list_page")
    ) {
      return null;
    }

    const defaultItem = {
      "@type": "ListItem",
      position: 1,
      item: { "@id": this.$config.appEndPoint, name: "Home" },
    };

    const dynamicBreadcrumbListItems = this.breadCrumbs.map(
      ({ pageTitle, url }, index) => ({
        "@type": "ListItem",
        position: index + 2,
        item: {
          "@id":
            index + 1 === this.breadCrumbs.length
              ? `${this.$config.appEndPoint}${this.$route.path}`
              : url ?? "",
          name: pageTitle,
        },
      })
    );

    return {
      script: [
        {
          hid: `jsonld-${this.pageType}`,
          type: "application/ld+json",
          json: {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [defaultItem, ...dynamicBreadcrumbListItems],
          },
        },
      ],
    };
  },

  mounted() {
    this.$store.dispatch("app/hydrateRedirectFrom");

    const redirectFrom = this.$store.state.app.redirectFrom;
    const pageTitle = this.$prismic.asText(this.pageTitle);

    const { url } = redirectFrom;
    const showPrevBreadCrumbItem =
      (url.includes("collections") ||
        url.includes("cart") ||
        url.includes("store")) &&
      (this.pageType === "Product_detail_page" ||
        this.pageType === "Store_page");

    this.breadCrumbs = showPrevBreadCrumbItem
      ? [redirectFrom, { pageTitle }]
      : [{ pageTitle }];
  },
};
